import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {carouselData.title}
          </h2>
          <p className="text-sm text-foreground-600">深入阅读51黑料网精选深度报道与专题策划</p>
        </div>
        <div className="space-y-5">
          {carouselData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl overflow-hidden flex flex-col md:flex-row group cursor-pointer"
            >
              <div className="w-full md:w-72 lg:w-96 flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-48 md:h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-3 w-fit whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-sm text-primary-600 font-medium">
                  <span>阅读全文</span>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}